export const INP_WIDTH = "Exportbreite";
export const INP_HEIGHT = "Exporthöhe";
export const INP_UNIT = "cm";